import React, { useEffect, useState } from 'react';
import { DeviceData } from "../../store/LabEquipment";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import "./utils/LabEquipment.css";
import { LabEquipmentOrderMap } from './utils/labEquipmentDataPreparator';
import EquipmentCard from './EquipmentCard';
import LabEquipmentApi from './utils/labEquipmentApi';

type EquipmentListProps = {
    equipment: LabEquipmentOrderMap;
    onSuccessfulStatusUpdate: () => void;
}

const EquipmentList = (props: EquipmentListProps) => {
    const { equipment, onSuccessfulStatusUpdate } = props;
    const robotNames: string[] = Object.keys(equipment);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState<DeviceData | null>(null);
    const [isSelectedDeviceBlocked, setIsSelectedDeviceBlocked] = useState(selectedDevice?.Lab_Instrument_blocked || false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleEdit = (device: DeviceData) => {
        setSelectedDevice(device);
        setModalOpen(true);
    };

    const handleCancelEdit = () => {
        setSelectedDevice(null);
        setErrorMessage(null);
        setModalOpen(false);
    }

    useEffect(() => {
        if (selectedDevice) {
            setIsSelectedDeviceBlocked(selectedDevice.Lab_Instrument_blocked)
        } else {
            setIsSelectedDeviceBlocked(false);
        }
    }, [selectedDevice])

    const handleSaveEquipmentStatus = () => {
        if (selectedDevice) {
            LabEquipmentApi.saveEquipmentState({
                methodDescription: selectedDevice.Method_description,
                robotCode: selectedDevice.Robot_Code,
                labInstrumentCode: selectedDevice.Lab_Instrument_code,
                labInstrumentBlocked: isSelectedDeviceBlocked
            }).then(() => {
                onSuccessfulStatusUpdate();
                setModalOpen(false);
                setSelectedDevice(null);
            }).catch((error) => {
                setErrorMessage(error.message)
            })
        }
    }

    

    if (!equipment || robotNames.length === 0) {
        return (
            <Col>
                <p>
                    You don't have any equipment registered yet. Please fill in the
                    form below to register new equipment
                </p>
            </Col>
        );
    }

    return (
        <>
            {robotNames.map((robotName: string, index: number) => (
                <Row key={index}>
                    <Row>
                        <Col>
                            <span className="robot-name-label">{robotName}</span>
                        </Col>
                    </Row>
                    <Row>
                        {equipment[robotName].map((device: DeviceData, deviceIndex: number) => (
                            <EquipmentCard key={deviceIndex} device={device} onEdit={handleEdit} />
                        ))}
                    </Row>
                </Row>
            ))}

            {selectedDevice && (
                <Modal isOpen={modalOpen} toggle={handleCancelEdit}>
                    <ModalHeader toggle={handleCancelEdit}>Manage Equipment</ModalHeader>
                    <ModalBody>
                        <>
                            {!errorMessage && <><label>Manufacturer Name</label>
                                <Input className="equipment-data-field" type="text" defaultValue={selectedDevice.Robot_Manufacturer_Name} disabled />
                                <label>Robot Name</label>
                                <Input className="equipment-data-field" type="text" defaultValue={selectedDevice.Robot_Name} disabled />
                                <label>Lab Instrument Code</label>
                                <Input className="equipment-data-field" type="text" defaultValue={selectedDevice.Lab_Instrument_code} disabled />
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            className="equipment-data-field"
                                            type="checkbox"
                                            checked={isSelectedDeviceBlocked}
                                            onChange={(e) => setIsSelectedDeviceBlocked(e.target.checked)}
                                        />
                                        Blocked
                                    </Label>
                                </FormGroup></>}
                            <span>{errorMessage}</span>
                        </>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={handleCancelEdit}>Cancel</Button>
                        {!errorMessage && <Button color="primary" onClick={handleSaveEquipmentStatus} disabled={isSelectedDeviceBlocked === selectedDevice?.Lab_Instrument_blocked}>Save</Button>}
                    </ModalFooter>
                </Modal>
            )}
        </>
    )
};

export default EquipmentList;
